export class GlobalSettings 
{

    public static isEmpty(val)
    {
        return (val === undefined || val == null || val.length <= 0);
    }

}